import LPGlider from 'ui/glider';

function initClearance () {

	let gliderInstance;
	let handleGliderLoaded;
	const gliderOptions = {
		slidesToShow: 8,
		slidesToScroll: 8,
		dots: false,
		rewind: false,
		duration: 0,
		arrows: {
			prev: '#clearanceSortWrapper .glider-prev',
			next: '#clearanceSortWrapper .glider-next'
		},
		responsive: [
			{
				// screens greater than >= 1280
				breakpoint: 1280,
				settings: {
					slidesToShow: 12,
					slidesToScroll: 12
				}
			}
		]
	};
	const gliderContainer = document.querySelector('.clearanceSort');

	if (gliderContainer) {

		handleGliderLoaded = function () {

			const glider = LPGlider(this);
			glider.setActiveSlide(0);
			this.parentElement.classList.remove('glider-loading');

		};
		gliderContainer.addEventListener('glider-loaded', handleGliderLoaded, { once: true });

		gliderInstance = new LPGlider(gliderContainer, gliderOptions);

	}

	return [
		function () {

			if (gliderInstance) {

				// Sometimes glider destroy expects an element that no longer exists
				// Related to pace of load/unload
				try {

					// Necessary to call destroy to cleanup window resize handlers
					gliderInstance.destroy();

				} catch (e) {}

			}

			if (gliderContainer && handleGliderLoaded) {

				gliderContainer.removeEventListener('glider-loaded', handleGliderLoaded);

			}

		}
	];

}

export default initClearance;
